export enum StorageDestinationActionTypes {
  STORAGE_SET_DESTINATION_TYPE = "STORAGE_SET_DESTINATION_TYPE",
  STORAGE_SET_DESTINATION_WAREHOUSE = "STORAGE_SET_DESTINATION_WAREHOUSE",
  STORAGE_SET_NEAREST_WAREHOUSE = "STORAGE_SET_NEAREST_WAREHOUSE",
  STORAGE_SET_WAREHOUSE_LIST = "STORAGE_SET_WAREHOUSE_LIST",
}
